module.exports = __webpack_public_path__ + "static/img/图书馆.141f8e1e.png";